import CompletedDocSection from '../../components/CompletedDocSection/CompletedDocSection';

export default function CompletedDocPage() {
  return (
      <CompletedDocSection />
  );
}
